import { Card, Splitter, Tabs, Typography } from 'antd'
import React from 'react'
import DepartmentPage from '../../../components/Manage/EmpoyeManage/Department/DepartmentPage'
import EmployessPage from '../../../components/Manage/EmpoyeManage/Employess/EmployessPage'
import UserManage from '../Users/UserManage'
import RolePage from '../../../components/Manage/EmpoyeManage/Roles/RolePage'
import ViewByDepartment from './ViewByDepartment'

const EmployeesPage = () => {

    const items = [
        {
            key: "1",
            label: "Departments",
            children: <DepartmentPage />,
        },
        {
            key: "3",
            label: "Roles",
            children: <RolePage />,
        },
        {
            key: "2",
            label: "Empoyees",
            children: <UserManage />,
        },
         {
            key: "4",
            label: "Department Overview",
            children: <ViewByDepartment />,
        },
        
    ]


    return (
        <>
            <Card
                title={<Typography.Title level={4} >Manage Employees</Typography.Title>}>

                <Tabs
                    tabPosition="left"
                    size="large"
                    defaultActiveKey="1"
                    items={items}
                />
            </Card>
        </>
    )
}

export default EmployeesPage
